import { ReinosMaps } from '../../core'

//----------------------------------------------
//remove single poly, cirlce, rectangle
//----------------------------------------------

ReinosMaps.prototype.removeArtOverlay = function (mapID, object_name, type) {
  const self = this

  //set the type array, always with s like polylines or circles
  const type_array = type + 's'
  let index

  if (type !== undefined && self[type_array] !== undefined) {
    //loop over the markers
    self[type_array][mapID].forEach((val, key) => {
      //search the array and set the index
      if (
        val['keys'] !== undefined
        && typeof (index) === 'undefined'
        && val['keys'].includes(object_name)
      ) {
        index = key
      }
    })

    //remove marker
    if (index !== undefined) {
      self[type_array][mapID] = self[type_array][mapID].filter((val, key) => index !== key)
    }

    //update markerNumber
    self[type_array][mapID].forEach((val, key) => {
      val['object'].objectNumber = key
      val['keys'][0] = key
    })
  }
}
